module.exports = __webpack_public_path__ + "img/alarm.28db83c5.svg";